import { GameType } from '@/models/games/enums/GameType';
import { PokerShow } from '@/models/games/PokerShow';
import {
    SupportedGameResult,
    SupportedGameState,
    SupportedGoodRoad,
} from '@/modules/host/models';

export type SupportedGameLiveData = {
    HostId: number;
    GameType: GameType;
    CurrentResult?: SupportedGameResult;
    CurrentStateTmp: SupportedGameState;
    CurrentState: SupportedGameState;
    SameStateSeq: number; //For BJ2
    PokerShowResult?: Array<PokerShow>;
    GoodRoad?: SupportedGoodRoad;
    IsGoodRoad: boolean;
    ResultReleased: boolean;

    CountDown: number;
    RemainTime: number;
    PendingTime?: number;
    CanLeave?: boolean;
    ShuffleTimer?: NodeJS.Timeout;
};

export type HostTableLive = SupportedGameLiveData;
export const initialLHostTable = {} as HostTableLive;
